import restCrudActions from '../../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../../np-rest/rest';
import { snackActions } from '../../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'client-organizational-unit',
    pluginName: 'CLIENT_ORGANIZATIONAL_UNIT',
    entityName: 'CLIENT_ORGANIZATIONAL_UNIT',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true,
    createSuccessUseBackendMessage: true,
    deleteFailedUseBackendMessage: true,
    editFailedUseBackendMessage: true,
    bulkDeleteFailedUseBackendMessage: true
});

// Fetch Client Organizational Unit action creators
export const fetchClientOrganizationalUnitInit = () => { return crudActions.fetchInit(); }
export const fetchClientOrganizationalUnitStart = () => { return crudActions.fetchStart(); }
export const fetchClientOrganizationalUnitSuccess = () => { return crudActions.fetchSuccess(); }
export const fetchClientOrganizationalUnitFail = () => { return crudActions.fetchFail(); }

export const fetchClientOrganizationalUnitsCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchClientOrganizationalUnitStart());
        try {
            let countRes = await rest.post("client-organizational-unit/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchClientOrganizationalUnitSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchClientOrganizationalUnitFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch clients organizational units."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchClientOrganizationalUnitFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch clients organizational units."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};

export const fetchClientOrganizationalUnits = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchClientOrganizationalUnitStart());
        try {
            let listRes = await rest.post("client-organizational-unit/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchClientOrganizationalUnitSuccess(filterData.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchClientOrganizationalUnitFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchClientOrganizationalUnitFail());

            return { data: [] };
        }
    }
};

// Create Client Organizational Unit  action creators
export const createClientOrganizationalUnitInit = () => { return crudActions.createInit(); };
export const createClientOrganizationalUnitStart = () => { return crudActions.createStart(); };
export const createClientOrganizationalUnitSuccess = createdClientOrganizationalUnit => { return crudActions.createSuccess(createdClientOrganizationalUnit); };
export const createClientOrganizationalUnitFail = error => { return crudActions.createFail(error); };
export const createClientOrganizationalUnit = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createClientOrganizationalUnitStart());
        try {
            let res = await rest.post('/client-organizational-unit/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created client organizational unit.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createClientOrganizationalUnitFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create client organizational unit."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create client organizational unit."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createClientOrganizationalUnitFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Delete Client Organizational Unit  action creators
export const bulkDeleteClientOrganizationalUnitInit = () => { return crudActions.bulkDeleteInit(); };
export const bulkDeleteClientOrganizationalUnitStart = () => { return crudActions.bulkDeleteStart(); };
export const bulkDeleteClientOrganizationalUnitSuccess = bulkDeleted => { return crudActions.bulkDeleteSuccess(bulkDeleted); };
export const bulkDeleteClientOrganizationalUnitFail = error => { return crudActions.bulkDeleteFail(error); };
export const bulkDeleteClientOrganizationalUnit = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteClientOrganizationalUnitStart());
        try {
            let res = await rest.post('/client-organizational-unit/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteClientOrganizationalUnitSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted clients organizational units.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteClientOrganizationalUnitFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete clients organizational units."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete clients organizational units."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteClientOrganizationalUnitFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit client  action creators
export const editClientOrganizationalUnitInit = () => { return crudActions.editInit(); };
export const editClientOrganizationalUnitStart = () => { return crudActions.editStart(); };
export const editClientOrganizationalUnitSuccess = editedClientOrganizationalUnit => { return crudActions.editSuccess(editedClientOrganizationalUnit); };
export const editClientOrganizationalUnitFail = error => { return crudActions.editFail(error); };

export const editClientOrganizationalUnit = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editClientOrganizationalUnitStart());
        try {
            let res = await rest.post('/client-organizational-unit/save', params);
            if (res.data && res.data.succeeded) {
                // dispatch(editClientOrganizationalUnitSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated client organizational unit.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editClientOrganizationalUnitFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit client organizational unit."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit client organizational unit."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editClientOrganizationalUnitFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Load client action creators
export const loadClientOrganizationalUnitInit = () => { return crudActions.loadInit(); };
export const loadClientOrganizationalUnitStart = () => { return crudActions.loadStart(); };
export const loadClientOrganizationalUnitSuccess = loadedClientOrganizationalUnit => { return crudActions.loadSuccess(loadedClientOrganizationalUnit); };
export const loadClientOrganizationalUnitFail = error => { return crudActions.loadFail(error); };
export const loadClientOrganizationalUnit = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};

